{
	"name": "vms",
	"version": "1.7.0",
	"author": "VMS",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"build": "ng build",
		"start:dev": "ng build --configuration development",
		"build-prod": "ng build -c production",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"lint": "ng lint",
		"lint-fix": "ng lint --fix",
		"format": "prettier --write ./src",
		"hm:build": "node --max_old_space_size=4096 node_modules/@angular/cli/bin/ng build --watch",
		"build:dev": "ng build --delete-output-path=false --progress=true --verbose=true --source-map=false --watch --poll 500 "
	},
	"private": true,
	"engines": {
		"node": ">=24.18.0",
		"npm": ">=11.16.0"
	},
	"dependencies": {
		"@angular/animations": "^21.2.18",
		"@angular/cdk": "^21.2.14",
		"@angular/common": "^21.2.18",
		"@angular/compiler": "^21.2.18",
		"@angular/core": "^21.2.18",
		"@angular/forms": "^21.2.18",
		"@angular/localize": "^21.2.18",
		"@angular/material": "^21.2.14",
		"@angular/platform-browser": "^21.2.18",
		"@angular/platform-browser-dynamic": "^21.2.18",
		"@angular/router": "^21.2.18",
		"@fortawesome/angular-fontawesome": "^4.0.0",
		"@fortawesome/free-brands-svg-icons": "^6.7.2",
		"@fortawesome/free-regular-svg-icons": "^6.7.2",
		"@fortawesome/free-solid-svg-icons": "^6.7.2",
		"@iplab/ngx-file-upload": "21.0.0",
		"@jonijnm/amazing-time-picker": "^2.2.0",
		"@ng-bootstrap/ng-bootstrap": "^20.0.0",
		"@ng-maps/core": "^8.0.0",
		"@ng-maps/google": "^8.0.0",
		"@ng-select/ng-option-highlight": "^21.8.2",
		"@ng-select/ng-select": "^21.8.2",
		"@ngx-translate/core": "^16.0.4",
		"@popperjs/core": "^2.11.8",
		"@sweetalert2/ngx-sweetalert2": "^15.0.0",
		"angular-archwizard": "^7.0.0",
		"angular-calendar": "^0.31.1",
		"angular-csv-ext": "1.0.5",
		"angular-feather": "^6.5.1",
		"angular-notifier": "^14.0.0",
		"animate.css": "^4.1.1",
		"apexcharts": "4.3.0",
		"bootstrap": "^5.3.3",
		"core-js": "^3.30.1",
		"date-fns": "^3.3.1",
		"dayjs": "^1.11.10",
		"file-saver": "^2.0.5",
		"hammerjs": "^2.0.8",
		"lodash": "^4.17.21",
		"lodash-es": "^4.17.21",
		"mapbox-gl": "^2.15.0",
		"moment": "^2.30.1",
		"mousetrap": "^1.6.5",
		"ng-apexcharts": "1.15.0",
		"ng-recaptcha": "^13.2.1",
		"ng2-date-picker": "21.0.1",
		"ngx-bootstrap": "^21.2.1",
		"ngx-chips": "^3.0.0",
		"ngx-clipboard": "^16.0.0",
		"ngx-color-picker": "^19.0.0",
		"ngx-image-cropper": "^8.0.0",
		"ngx-mapbox-gl": "^11.0.1",
		"ngx-mask": "^19.0.7",
		"ngx-print": "^1.5.1",
		"ngx-scrollbar": "^18.0.0",
		"ngx-toastr": "19.0.0",
		"rxjs": "~7.8.1",
		"screenfull": "^6.0.2",
		"sct-custom-table": "git+https://bitbucket.org/smartchargetech/sct-fw.git#ag21-1.1.0",
		"sim-management-frontend": "git+https://bitbucket.org/smartchargetech/sim_managment_srv.git#sim-management-ui-21",
		"sweetalert2": "^11.12.0",
		"tslib": "^2.6.3",
		"xlsx": "https://cdn.sheetjs.com/xlsx-0.20.2/xlsx-0.20.2.tgz",
		"zone.js": "~0.15.1"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^21.2.19",
		"@angular-eslint/builder": "21.4.0",
		"@angular-eslint/schematics": "21.4.0",
		"@angular/build": "^21.2.19",
		"@angular/cli": "^21.2.19",
		"@angular/compiler-cli": "^21.2.18",
		"@eslint/js": "^10.0.1",
		"@types/google.maps": "3.58.0",
		"@types/hammerjs": "^2.0.45",
		"@types/lodash": "^4.17.6",
		"@types/lodash-es": "^4.17.12",
		"@types/mousetrap": "^1.6.15",
		"@types/node": "^24.0.0",
		"@vitest/coverage-v8": "^4.1.12",
		"angular-eslint": "21.4.0",
		"eslint": "^10.14.0",
		"jsdom": "^30.1.3",
		"prettier": "^3.3.2",
		"typescript": "5.9.3",
		"typescript-eslint": "^8.72.1",
		"vitest": "^4.1.12"
	},
	"overrides": {
		"@hono/node-server": "^2.0.5",
		"uuid": "^11.1.1",
		"webpack-dev-server": "^5.2.6",
		"postcss": "^8.5.18",
		"less": "^4.8.1",
		"@angular/build": {
			"undici": "^7.30.1"
		},
		"cacache": {
			"glob": "^14.0.3"
		},
		"@npmcli/package-json": {
			"glob": "^14.0.3"
		},
		"@tufjs/models": {
			"minimatch": "^11.0.4"
		},
		"@typescript-eslint/typescript-estree": {
			"minimatch": "^11.0.4"
		},
		"eslint": {
			"minimatch": "^11.0.4"
		},
		"@eslint/config-array": {
			"minimatch": "^11.0.4"
		},
		"ignore-walk": {
			"minimatch": "^11.0.4"
		},
		"angular-notifier": {
			"@angular/common": "^21.0.0",
			"@angular/core": "^21.0.0"
		},
		"ng-apexcharts": {
			"@angular/common": "^21.0.0",
			"@angular/core": "^21.0.0"
		},
		"ng-recaptcha": {
			"@angular/common": "^21.0.0",
			"@angular/core": "^21.0.0"
		},
		"ngx-mapbox-gl": {
			"@angular/common": "^21.0.0",
			"@angular/core": "^21.0.0"
		}
	},
	"allowScripts": {
		"@parcel/watcher": true,
		"@scarf/scarf": true,
		"core-js": true,
		"esbuild": true,
		"lmdb": true,
		"msgpackr-extract": true
	}
}
